var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDropdownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3751 0.50002L6.4951 4.38002L2.6151 0.50002C2.2251 0.11002 1.5951 0.11002 1.2051 0.50002C0.815098 0.89002 0.815098 1.52002 1.2051 1.91002L5.7951 6.50002C6.1851 6.89002 6.8151 6.89002 7.2051 6.50002L11.7951 1.91002C12.1851 1.52002 12.1851 0.89002 11.7951 0.50002C11.4051 0.12002 10.7651 0.11002 10.3751 0.50002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdownBlack);
export default __webpack_public_path__ + "static/media/ic_dropdown_black.4aa69b9aab492960404f92c0b45f91e5.svg";
export { ForwardRef as ReactComponent };